import { getReleaseVersion } from '#shared/helpers/getAppVersion';
import { isProdBuildMode } from '~/shared/helpers/buildMode';

export const init = () => {
  if (import.meta.client) {
    (navigator as any).__defineGetter__('appName', function () {
      return 'Магнит Маркет'; // customized user agent
    });

    // @todo put real version ("app_version": "3.0.0-DEBUG-1120724")
    (navigator as any).__defineGetter__('appVersion', function () {
      return getReleaseVersion(); // customized user agent
    });
    // Ждем загрузки ClickStreamSDK_WEB
    const initSDK = () => {
      const ClickStreamSDK_WEB = (globalThis as any).ClickStreamSDK_WEB;

      if (!ClickStreamSDK_WEB) {
        setTimeout(initSDK, 0);
        return;
      }

      try {
        const config = new ClickStreamSDK_WEB.ru.tander.clickstream.core.ClickStreamConfig(
          new ClickStreamSDK_WEB.ru.tander.clickstream.core.ClickStreamConfig.Range(5, 15),
          10, // batchSize
          25, // flushInterval
          20 // timeout
        );

        // Инициализируем SDK
        // @todo environment
        ClickStreamSDK_WEB.ClickStreamSDK.initialize(
          'https://event-stream-api.magnit.ru',
          config,
          (param: any) => {
            if (isProdBuildMode()) return;
            console.log('ClickStreamSDK log:', param);
          }
        );
        // Error(message=Intercept exception in coroutine., type=UNKNOWN, exception=Au) значит, что в payload есть undefined

        // Делаем SDK доступным глобально для компонентов
        (globalThis as any).$clickstreamSDK = ClickStreamSDK_WEB;
        // Сообщаем трекеру о готовности SDK (для сброса очереди событий)
        try {
          const { tracker } = require('./ClickStreamTracker');
          tracker.notifyReady();
        } catch {}
      } catch (error) {
        console.error('ClickstreamPlugin: Ошибка инициализации SDK:', error);
      }
    };

    // Начинаем инициализацию
    initSDK();
  }
};
